export default __webpack_public_path__ + "static/media/space.80687b01.jpg";